import React, {Component} from 'react';
import Relay from 'react-relay';
import cookie from '../helper/cookie'

export default class Navbar extends Component{

	constructor(props)
	{
		super(props);
		this.logout=this.logout.bind(this);
		this.profile=this.profile.bind(this);
	}

	static propTypes = {
	    children: React.PropTypes.node.isRequired
	};

	logout() {
	    var cookies = document.cookie.split(";");

	    for (var i = 0; i < cookies.length; i++) {
	    	var cookie = cookies[i];
	    	var eqPos = cookie.indexOf("=");
	    	var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
	    	document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
	    }
		
		// var url = window.location.href;
		window.history.go(-window.history.length);
		// window.location.href = url;
		window.location.href = "/#/login";
	}

	profile() {
		window.location.href = "/#/profile/" + cookie.get('userId');
	}

	onNewTodoSave = (text) => {};
	render(){
		const { children } = this.props;

		var padding5={
			padding:5,
			height:50,
			width:50
		}

		var padding20={
			padding:20
		}

		var brandStyle={
			fontSize:24,
			letterSpacing:0.4,
			color:'black'
		}
		// TODO this is not working, find some fix.
		var navbarStyle={
			backgroundColor:'white',
			border: 'solid 0.5px #d8d8d8'
		}

		var styleHidden={
			display:'none'
		}

		var searchInputStyle={
			paddingTop: 6,
			paddingRight: 40,
			paddingBottom: 6,
			paddingLeft: 15,
			margin:3,
			background: 'url("https://dndw32r4edmw5.cloudfront.net/search_icon.png") no-repeat',
			backgroundPosition:'97% 98%', //x pos and y pos
			borderRadius:100,
			MozBorderRadius:100,
			WebkitBorderRadius:100,
			/*
			'border-radius':15,
			'-moz-border-radius':15,
			'-webkit-border-radius':15,
			*/
		};



		return(
			<div>
				<nav role="navigation" className="navbar navbar-default" style={navbarStyle}>
					<div className="navbar-header">
	            		<button type="button" data-target="#navbarCollapse" data-toggle="collapse" className="navbar-toggle">
	                		<span className="sr-only">Toggle navigation</span>
	                		<span className="icon-bar"></span>
	                		<span className="icon-bar"></span>
	                		<span className="icon-bar"></span>
	            		</button>
	            		<a className="navbar-brand" style={brandStyle}>Survey<b>mate</b></a>
	        		</div>
	        		<div id="navbarCollapse" className="collapse navbar-collapse" >
						<div className="dropdown navbar-right" id="override">
							<span data-toggle="dropdown" className=" chika dropdown-toggle glyphicon glyphicon-chevron-down" style={padding20}></span>
							<ul className="dropdown-menu list-group">
								<a className="hoverHandle list-group-item" onClick={this.profile}>Profile</a>
								<a className="hoverHandle list-group-item" onClick={this.logout}>Logout</a>
							</ul>
						</div>
						<img src="http://dndw32r4edmw5.cloudfront.net/avatar/Male.png" className='img-circle img-responsive navbar-right' style={padding5} />
					</div>
				</nav>
				<div data-framework="relay">
	          		{children}
	      		</div>
			</div>
		);
	}

}

// export default Relay.createContainer(Navbar, {
//   initialVariables: {
//     status: null
//   },
//   fragments: {
//     viewer: () => Relay.QL`
//       fragment on User {
//         pid
//         email
//         name
//         picture
//       }
//     `
//   }
// });




/** WEBPACK FOOTER **
 ** ./src/components/navbar.js
 **/